import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./CustomerNavbar";
import { Container, Row, Col } from "react-bootstrap";
import styled from "styled-components";
import CustomerSidebar from "./customerSidebar";

const PageStyles = styled.div``;

const PageContainer = styled.div`
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  .scroll-div {
    position: sticky;
    top: 0;
    z-index: 100;
    width: 100%;
    height: auto;
    background-color: #232631;
  }
`;

const ContentContainer = styled(Container)`
  /* overflow: auto; */
  max-width: 100%;
  flex: 1;
`;
const StickyDiv = styled.div`
  position: relative;
`;

const SidebarContainer = styled.div`
  position: relative;
  height: 100%;
  /* width: auto;
  overflow: auto; */
  display: block;
  /* border: 5px solid green; */
  z-index: 50000;
`;

const PrivateLayout = (props) => {
  const [scroll, setScroll] = useState(false);
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [mobileSidebarCollapsed, setMobileSidebarCollapsed] = useState(true);
  const page = location.pathname.split("/")[1];

  const user = {
    firstName: "Richard",
    lastName: "",
  };

  const handleResize = () => {
    const mobile = window.innerWidth <= 768;
    setIsMobile(mobile);
    if (!mobile) {
      setMobileSidebarCollapsed(true); // Keep it closed on desktop view
    }
  };

  const toggleMobileSidebar = () => {
    setMobileSidebarCollapsed(!mobileSidebarCollapsed);
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 0);
    });
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <PageContainer>
      <SidebarContainer>
        <CustomerSidebar
          isMobile={isMobile}
          mobileSidebarCollapsed={mobileSidebarCollapsed}
          toggleMobileSidebar={toggleMobileSidebar}
        />
      </SidebarContainer>
      <ContentContainer>
        <StickyDiv
          className={scroll && page === "scenario" ? "scroll-div" : "no-scroll"}
        >
          <Row>
            <Col>
              <Navbar
                name={`${user?.firstName} ${user?.lastName}`}
                toggleMobileSidebar={toggleMobileSidebar}
              />
            </Col>
          </Row>
        </StickyDiv>
        <Row>
          <Col>
            <>{props.children}</>
          </Col>
        </Row>
      </ContentContainer>
    </PageContainer>
  );
};

export default PrivateLayout;